import React from 'react';

import WarningPanel from './WarningPanel';

import Loading from './Loading';

import styles from '../styles/DynamicModal.module.css';

import IconContainer from './IconContainer';
import { ReactComponent as XIcon } from '../icons/x-close.svg';

const ExplanationModal = ({ closeModal, formInfo, setFormInfo, circumstance = '', onSuccess }) => {
    const [status, setStatus] = React.useState('');
    const [loading, setLoading] = React.useState(false);

    const handleChange = (field) => (e) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

        setFormInfo((prev) => ({ ...prev, [field]: value }));

        setStatus('Сохраните изменения');

        setErrorsForm((prevErrors) => {
        if (!prevErrors[field]) return prevErrors;
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[field];
            return updatedErrors;
        });
    };

    const [errorsForm, setErrorsForm] = React.useState({});
        const validateForm = () => {
        const newErrors = {};
    
        if (!formInfo.name) {
            newErrors.name = 'Обязательное поле';
        }
        if (formInfo.name && (formInfo.name.length < 2 || formInfo.name.length > 50)) {
            newErrors.name = 'Значение не может быть меньше 2 и более 50 символов';
        }
    
        setErrorsForm(newErrors);
        if (Object.keys(newErrors).length > 0) {
            setStatus(<a className='mainLabelError'>Данные не сохранены. Проверьте корректность введенных полей</a>);
            return false;
        } else {
            return true;
        }
    };

    const handleSave = () => {
        setLoading(true);
        setStatus(<a><Loading type='inline' /></a>);

        if (validateForm()) {
            onSuccess();
        }
        setLoading(false);
    }


    return (
        <div className={styles.liningOver}>
            <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>Объясните решение</h1>
                    <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                </div>
                <div className={styles.main}>
                    <WarningPanel text={circumstance} />
                    <div className='labelInputWrapper'>
                        <a className='label'>Опишите причину изменения</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <textarea 
                                    cols='10' 
                                    rows='10' 
                                    value={formInfo.comment_explanation}  
                                    onChange={handleChange('comment_explanation')}
                                    className={errorsForm.comment_explanation ? 'inputError' : ''}
                                    minLength='' 
                                    maxLength='300' 
                                    require=''
                                >
                                </textarea>
                                <p className='description'>{formInfo.comment_explanation.length}/300</p>
                                {errorsForm.comment_explanation && <div className='errorUnderInput'>{errorsForm.comment_explanation}</div>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.bottom}>
                    <div>{status}</div>
                    <div className={styles.manyButtonsWrapper}>
                        <button 
                        type='button' 
                        className='button optionalButton' 
                        onClick={closeModal}
                        disabled={loading}
                        >
                            Отменить
                        </button>
                        <button 
                        type='button' 
                        className='button' 
                        onClick={handleSave}
                        disabled={loading}
                        >
                            Продолжить
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ExplanationModal;